// Module-level mirror of whether the primary (`/ui`) websocket is currently
// down. It is kept in sync by MultiWebsocket -- the single owner of the `/ui`
// socket -- alongside the redux `hasWebsocketError` flag that drives the top
// "Connection to backend lost" banner.
//
// Secondary live-data subscriptions (per-record updates, resource-stats
// widgets, the dependency visualization) read this to suppress their own
// redundant "Could not load live data" connection-error toasts while the
// primary connection is already down: the banner is the single persistent
// signal for that outage, so each secondary socket's reconnect-storm error
// event must not raise a fresh toast on top of it. A plain module-level flag
// (rather than reading the redux store from leaf util modules / static
// services) keeps those call sites synchronous and store-agnostic.
let uiWebsocketDown = false;

export const setUiWebsocketDown = (down: boolean): void => {
    uiWebsocketDown = down;
};

export const isUiWebsocketDown = (): boolean => uiWebsocketDown;
